import { render, staticRenderFns } from "./ProjectCarousel.vue?vue&type=template&id=3930c9af&scoped=true&lang=pug&"
import script from "./ProjectCarousel.vue?vue&type=script&lang=js&"
export * from "./ProjectCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCarousel.vue?vue&type=style&index=0&id=3930c9af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930c9af",
  null
  
)

export default component.exports